<template>
    <v-container fluid grid-list-md style="padding:0px; margin:0px !important;">
        <v-layout column style="padding:0px;">
            <v-flex d-flex md1 style="align-items:center;font-size:16px;" class="trend-line-title">
                <span>{{trendData.title}} [{{trendData.unit}}]</span>
            </v-flex>
            <v-flex v-if="typeof trendData.value == 'undefined' || trendData.value==-1000" d-flex md1 style="align-items:center;font-size:22px;" class="trend-line-display">
                <span>-</span>
            </v-flex>
            <v-flex v-else d-flex md1 style="align-items:center;font-size:22px;" class="trend-line-display">
                <span>{{trendData.value.toFixed(trendData.format)}}</span>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    import {Chart} from 'highcharts-vue'

    export default {
        name: "Trendline",
        components: {
            highcharts: Chart
        },
        props: {
            trendData:Object
        },
        computed: {
            optionsFinalized : function () {
                var tmp = this.chartOptions;

                tmp.credits = false;

                return tmp;
            }
        },
        data: function () {
            return {
                chartOptions:{}
            }
        },
        methods: {
        },
        mounted() {

            this.chartOptions = JSON.parse(JSON.stringify(this.trendData.chartOptions));
            this.chartOptions.title = { text:undefined };
            this.chartOptions.yAxis= {
                    labels:{ enabled:false },
                    title:{ text:undefined}};
            this.chartOptions.time= { useUTC:false };
            this.chartOptions.tooltip= {
                    formatter: function () {
                        return this.points.reduce(function (s, point) {
                            return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                        //}, '<b>' + this.x + '</b>');
                        }, '<b>' + new Date(this.x).toTimeString().substring(0,5) + '</b>');
                    },
                    shared:true
                };
        },
        watch: {
            trendData:function() {
                this.chartOptions = JSON.parse(JSON.stringify(this.trendData.chartOptions));
                this.chartOptions.title = { text:undefined };
                this.chartOptions.yAxis= {
                    labels:{ enabled:false },
                    title:{ text:undefined}};
                this.chartOptions.time= { useUTC:false };
                this.chartOptions.tooltip= {
                    formatter: function () {
                        return this.points.reduce(function (s, point) {
                            return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                        //}, '<b>' + this.x + '</b>');
                        }, '<b>' + new Date(this.x).toTimeString().substring(0,5) + '</b>');
                    },
                    shared:true
                };

            }
        }
    }
</script>

<style scoped>
</style>
